export const WEBHOOK_URL = 'https://n8n.rushel.me/webhook/40e189be-b43b-4b00-854b-b30c01b71479';

export const EVENT_DETAILS = {
    date: 'Sunday, October 26, 2025',
    time: '9:00 AM',
    venue: {
        name: 'Schulhaus Feldheim 3',
        address: '6312 Steinhausen'
    }
};

export const FOOD_PREFERENCES = [
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'non-vegetarian', label: 'Non-Vegetarian' },
    { value: 'fasting', label: 'Fasting (No Food)' },
    { value: 'fruits-only', label: 'Fruits & Light Snacks Only' }
];

export const MAX_GUESTS = 8;